import Request from './Request'

const PlanCentralService = {
	getHealth: async () => {
		return Request.get('/api/admin/plan-central/health')
	},
	getFleet: async (clientId) => {
		return Request.get('/api/admin/plan-central/fleet', { client_id: clientId })
	},
	getClassDetail: async (locationClassId) => {
		return Request.get(`/api/admin/plan-central/classes/${locationClassId}`)
	},
	setMethod: async (locationClassId, method) => {
		return Request.post(`/api/admin/plan-central/classes/${locationClassId}/method`, { method })
	},
	rebuild: async (locationClassId) => {
		return Request.post(`/api/admin/plan-central/classes/${locationClassId}/rebuild`, {})
	},
	rebuildClientForecasts: async (clientId) => {
		return Request.post(`/api/admin/plan-central/clients/${clientId}/rebuild-forecasts`, {})
	},
	getRunStatus: async (dagRunId, locationClassId) => {
		return Request.get(`/api/admin/plan-central/runs/${encodeURIComponent(dagRunId)}/classes/${locationClassId}`)
	},
}

export default PlanCentralService
